export default {"src":"https://fishbrain.com/_next/static/media/circle_green.cf82c899.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};